import { IDeleteLineItemProps } from './DeleteLineItem.types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { useDeleteLineItemStyles } from './DeleteLineItem.styles';
import RemoveItemPopup from '../../../popups/RemoveItemPopup/RemoveItemPopup';
import { useState } from 'react';
import { useLineEdit } from '../../../../../contexts/LineEditContext/LineEditContext.hooks';
import { mergeClasses } from '@fluentui/react-components';

const DeleteLineItem = (props: IDeleteLineItemProps) => {
    const { lineNumber, icon = faTrashCan, iconClassName } = props;
    const styles = useDeleteLineItemStyles();

    const [removeItemPopup, setRemoveItemPopup] = useState(false);

    const { removeLine } = useLineEdit();

    const closeRemoveItemPopup = (shouldDelete: boolean) => {
        setRemoveItemPopup(false);
        if (shouldDelete) {
            removeLine(lineNumber);
        }
    };

    const mergedIconClassName = mergeClasses(styles.deleteIcon, iconClassName);

    return (
        <div className={styles.root}>
            <FontAwesomeIcon
                data-testid={`line-${lineNumber}-delete-button`}
                className={mergedIconClassName}
                icon={icon}
                onClick={() => setRemoveItemPopup(true)}
            />

            <RemoveItemPopup showPopup={removeItemPopup} onDialogClose={closeRemoveItemPopup} />
        </div>
    );
};

export default DeleteLineItem;
